"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleEnterKey = handleEnterKey;
// Enter-to-send / Shift+Enter-for-newline, ported from ConversationHelper.js.
function handleEnterKey(event, sendCallback) {
  if (event.key === "Enter" && !event.shiftKey) {
    event.preventDefault();
    sendCallback();
  }
}